<template>
  <div class="main">
    <div class="tableContent"></div>
    <el-card style="padding-bottom: 50px">
      <div class="head" style="width: 100%">
        <el-button @click="toAdd" type="primary">新增</el-button>
      </div>

      <div class="mtTable">
        <el-table
          :header-cell-style="{
            'text-align': 'center',
            background: 'rgb(240, 247, 253)'
          }"
          border
          default-expand-all
          :data="tableData1"
          style="width: 50%"
          row-key="Id"
          lazy
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column prop="Name" label="节点名称"></el-table-column>
          <el-table-column align="center" prop="DateRule" label="数据规则" width="180">
            <template slot-scope="{ row }">
              <span>{{ row.ParentId == 0 ? '' : treeOptions2[row.DateRule] }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="address" label="映射数据">
            <template slot-scope="{ row }">
              <span>{{ findItemNameById(row.DataMappingId) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row }">
              <el-link style="margin-right: 15px" @click="toTbAdd(row)" :underline="false">
                <div style="display: flex; align-items: center">
                  <img style="margin-right: 5px; width: 16px; height: 16px; margin-top: 1px" src="../../assets/image/icon/PatientPortrait2.png" alt />
                  新增
                </div>
              </el-link>
              <el-link style="margin-right: 15px" @click="toTbEdit(row)" :underline="false">
                <div style="display: flex; align-items: center">
                  <img style="margin-right: 5px; width: 16px; height: 16px; margin-top: 1px" src="../../assets/image/icon/PatientPortrait2.png" alt />
                  编辑
                </div>
              </el-link>
              <el-link style="margin-right: 15px" @click="toTbDel(row)" :underline="false">
                <div style="display: flex; align-items: center">
                  <img style="margin-right: 5px; width: 16px; height: 16px; margin-top: 1px" src="../../assets/image/icon/PatientPortrait2.png" alt />
                  删除
                </div>
              </el-link>
              <el-link style="margin-right: 15px" @click="toLink(row)" :underline="false">
                <div style="display: flex; align-items: center">
                  <img style="margin-right: 5px; width: 16px; height: 16px; margin-top: 1px" src="../../assets/image/icon/PatientPortrait2.png" alt />
                  关联问卷
                </div>
              </el-link>

              <!-- <el-button @click="toTbAdd(row)" type="text" size="small">编辑</el-button>
            <el-button @click="toTbDel(row)" type="text" size="small">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <el-dialog title="节点处理" :visible.sync="dialogVisible" width="38%">
      <div class="mainDialog">
        <el-form label-width="80px" :model="form">
          <el-form-item label="名称">
            <el-input v-model="form.Name"></el-input>
          </el-form-item>
          <el-form-item v-if="isChild" label="映射数据">
            <el-select @change="changeIt" v-model="form.DataMappingId" placeholder="请选择" filterable>
              <el-option v-for="itemc in options" :key="itemc.Id" :label="itemc.Name" :value="itemc.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="isChild" label="数据规则">
            <el-select v-model="form.DateRule" placeholder="请选择">
              <el-option v-for="itemc in treeOptions" :key="itemc.value" :label="itemc.label" :value="itemc.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker :picker-options="startDatePicker" v-model="form.StartTime" type="date" placeholder="选择日期" style="width: 100%"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker :picker-options="overDatePicker" v-model="form.EndTime" type="date" placeholder="选择日期" style="width: 100%"></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="formAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisibleWen" width="30%" destroy-on-close>
      <div slot="title">
        <span style="color: #fff">问卷关联</span>
      </div>
      <div>
        <el-form :model="wenjuanForm" :rules="rules" ref="wenjuan">
          <el-form-item label="问卷列表" prop="Qval">
            <el-select v-model="wenjuanForm.Qval" placeholder="请选择" @change="QuestionnaireTableChange" style="margin-bottom: 10px">
              <el-option v-for="(item, index) in QuestionnaireTable" :key="index" :label="item.questionnaireName" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="btn">
        <button @click="dialogVisibleWen = false">取 消</button>
        <button type="primary" @click="determine">确 定</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import derive from '@/api/derive.js';
import tree from '@/api/tree';
import { treeOptions, treeOptions2 } from '@/utils/dictionary.js';
import { generateNestedTree } from '@/utils/tree.js';
import smartSearch from '../../api/smartSearch.js';
export default {
  data() {
    return {
      selectId: '',
      rules: {
        Qval: [{ required: true, message: '请选择问卷', trigger: 'blur' }]
      },
      QuestionnaireTable: [],
      wenjuanForm: {
        Qval: ''
      },
      dialogVisibleWen: false,
      startDatePicker: {
        disabledDate: time => {
          if (this.form.EndTime) {
            return time.getTime() > new Date(this.form.EndTime);
          }
        }
      },
      overDatePicker: {
        disabledDate: time => {
          if (this.form.StartTime) {
            return time.getTime() < new Date(this.form.StartTime) - 1000 * 3600 * 24;
          }
        }
      },
      isEdit: null,
      tableId: null,
      isChild: null,
      treeOptions: treeOptions,
      treeOptions2: treeOptions2,
      options: [],
      pageSet: {
        page: 1,
        rows: 1000
      },
      form: {},
      dialogVisible: false,
      tableData1: []
    };
  },
  created() {
    this.getData(this.pageSet);
    this.getList();
    this.QuestionnaireGetPageList();
  },
  methods: {
    QuestionnaireGetPageList() {
      const parameter = {
        ProjectId: 'all'
      };
      derive.CRFSurfaceData(parameter).then(res => {
        if (res.data.Status == 1) {
          this.QuestionnaireTable = res.data.Data;
        } else {
          alert(res.data.Message);
        }
      });
    },

    //选择问卷后调用随访接口
    QuestionnaireTableChange(e) {
      if (e.issueState == false) {
        this.Qval = '';
        alert('请先去发布问卷');
      }
    },
    determine() {
      this.$refs.wenjuan.validate(valid => {
        if (valid) {
          const parameter = {
            Id: this.selectId,
            Qid: this.wenjuanForm.Qval
          };
          console.log(parameter, 77);
          derive.QuestionSynDateSet(parameter).then(res => {
            this.$message({
              message: '关联成功',
              type: 'success'
            });
            console.log(res);
            this.getData(this.pageSet);
          });
          this.dialogVisibleWen = false;
        }
      });
      // this.dialogVisibleWen = false;
    },
    toLink(val) {
      this.wenjuanForm = {
        Qval: ''
      };
      this.selectId = val.Id;
      this.dialogVisibleWen = true;
    },
    changeIt(data) {
      const item = this.options.find(item => item.Id === data);
      this.form.IsDisplay = item.IsDisplay;
      // this.options.find(item => item.Id === data).Name = item.Name + '/' + item.System;
      // 给 select name 赋值 name/System
      // item.Name = item.Name + '/' + item.System;
      console.log(item);
    },
    findItemNameById(data) {
      const item = this.options.find(item => item.Id === data);
      return item ? item.Name : '';
    },
    toTbEdit(row) {
      if (row.ParentId != 0) {
        this.isChild = true;
        // this.form.ParentId = this.tableId;
      } else {
        this.isChild = false;
        this.form.IsDisplay = false;
      }

      this.form = {
        Id: row.Id,
        ParentId: row.ParentId,
        Name: row.Name,
        DataMappingId: row.DataMappingId,
        DateRule: row.DateRule,
        StartTime: row.StartTime,
        EndTime: row.EndTime,
        IsDisplay: row.IsDisplay
      };
      this.dialogVisible = true;
      this.isEdit = true;
    },
    formAdd() {
      if (this.isEdit) {
        tree.Update(this.form).then(res => {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          console.log(res);
          this.getData(this.pageSet);
        });
        this.dialogVisible = false;
      } else {
        if (this.isChild) {
          this.form.ParentId = this.tableId;
        } else {
          this.form.ParentId = 0;
          this.form.IsDisplay = false;
        }

        tree.Add(this.form).then(res => {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          console.log(res);
          this.getData(this.pageSet);
        });
        this.dialogVisible = false;
      }

      console.log(this.form);
    },
    getList() {
      smartSearch.GetPageList(this.pageSet).then(e => {
        this.options = e.data.Data.rows;
        this.options.forEach(item => {
          if (item.System === '' || item.System === null) {
            return;
          } else {
            item.Name = item.Name + '(' + item.System + ')';
          }
        });
        console.log(e);
      });
    },
    getData(val) {
      tree.GetPageList(val).then(res => {
        console.log(val);
        console.log(res.data.Data.rows);
        const arr = generateNestedTree(res.data.Data.rows);
        console.log(arr);
        this.tableData1 = arr;
        console.log(this.tableData1);
      });
    },

    toTbAdd(val) {
      this.form = {};
      this.isChild = true;
      this.dialogVisible = true;
      this.tableId = val.Id;
      console.log(val);
    },
    toTbDel(val) {
      this.$confirm('此操作删除该节点, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = [val.Id];
          tree.Delete(params).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            console.log(res);
            this.getData(this.pageSet);
          });
        })
        .catch(() => {});

      console.log(val);
    },

    toAdd() {
      this.form = {};
      this.isChild = false;
      this.isEdit = false;
      this.dialogVisible = true;
    },

    load(tree, treeNode, resolve) {
      setTimeout(() => {
        resolve([
          {
            id: 31,
            date: '2016-05-01',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1519 弄'
          },
          {
            id: 32,
            date: '2016-05-01',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1519 弄'
          }
        ]);
      }, 1000);
    },
    handleClose(done) {
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    }
  }
};
</script>

<style scoped lang="scss">
.main {
  /* display: flex;
  justify-content: center; */
  /* width: 100%; */
  height: 79vh;
  overflow: auto;
  padding: 20px;
}

.head {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.mtTable {
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: center;
}

/deep/ .el-dialog__title {
  color: #fff;
}

/deep/ .el-input__inner {
  width: 400px;
}
/deep/ .el-form-item__content {
  width: 100% !important;
}

.mainDialog {
  width: 80%;
  margin: 0 auto;
}
/deep/ .el-date-editor {
  width: 400px !important;
}
</style>
